import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const imageContainer = ({ breakpoints }: Theme) => ({
  borderRadius: "25px",
  backgroundColor: "white",
  p: 2,
  height: "200px",
  mt: 1,
});

export const imgButtonContaier = ({ breakpoints }: Theme) => ({
  position: "absolute",
  top: "85%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});

export const subTitle = ({ breakpoints }: Theme) => ({
  color: colors.main,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "22.4px",
});
